module.exports = __webpack_public_path__ + "img/shareSf.4c3a11e8.png";